import { render, staticRenderFns } from "./PayrollRunsList.vue?vue&type=template&id=32a5176c&scoped=true"
import script from "./PayrollRunsList.vue?vue&type=script&lang=js"
export * from "./PayrollRunsList.vue?vue&type=script&lang=js"
import style0 from "./PayrollRunsList.vue?vue&type=style&index=0&id=32a5176c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5176c",
  null
  
)

export default component.exports